export const loginMode = {
  mondiaPay: 'm',
}
